import {
  Card,
  Divider,
  Icon,
  RadioButtonGroup,
  typography,
} from '@joor/design-system'
import styled from 'styled-components'

import { CssGrid, Flex } from 'styles/components'

import { Number } from 'components/Core'

export const TransactionHistoryGrid = styled(CssGrid)`
  .cell {
    min-height: 40px;
    display: flex;
    align-items: center;
  }
  .with-bottom-border {
    border-bottom: 1px solid var(--color-primary-200);
  }
  .error {
    color: var(--color-error-700);
  }
  .header {
    font-size: var(--size-font-extrasmall);
    color: var(--color-primary-800);
    font-weight: var(--font-weight-medium);
  }
  .text-right {
    text-align: right;
    justify-content: right;
  }
  .icon-cell svg {
    width: 40px;
    height: auto;
  }
  .icon-cell > span > span {
    display: flex;
    padding: 4px 0;
  }
  .total-header {
    grid-column: 1 / 4;
    margin-left: -8px;
    padding-left: 8px;
    background-color: var(--color-primary-100);
    border-radius: 3px 0 0 3px;
    font-weight: var(--font-weight-bold);
  }
  .grid-column-5 {
    grid-column: 1 / 5;
  }
  .total {
    margin-right: -8px;
    padding-right: 8px;
    background-color: var(--color-primary-100);
    border-radius: 0 3px 3px 0;
    font-weight: var(--font-weight-bold);
  }
  .no-wrap {
    white-space: nowrap;
    padding-left: 2px;
  }
`

export const CardItemHeader = styled.div<{ variant?: 'order' }>`
  font-size: var(--size-font-small);
  font-weight: var(--font-weight-semibold);
  color: var(
    ${({ variant }) =>
      variant === 'order' ? '--color-primary-400' : '--color-primary-800'}
  );
  font-family: var(--font-family-alpha);
`

export const CardItemInfo = styled.div`
  font-family: var(--font-family-alpha);
  white-space: pre-line;
`

export const StyledDivider = styled(Divider)`
  > div {
    margin-right: 0;
    margin-left: 0;
  }
`

export const StyledNumberInput = styled(Number)`
  position: relative;
  input {
    text-align: right;
    border-color: var(--color-primary-400);
    color: var(--color-error-700);
    padding: 4px 8px;
    width: 118px;
    height: 28px;
    border-radius: 5px;
    font-size: var(--size-font-small);
  }
`

export const EditTaxIcon = styled(Icon)`
  position: absolute;
  z-index: 1;
  left: 10px;
  top: 5px;
`

export const MakePaymentCard = styled(Card)`
  font-family: var(--font-family-alpha);
  > header {
    background-color: var(--color-primary-700);
    span,
    > div > div {
      color: var(--color-neutral-000-full);
    }
  }
  > section {
    margin: 0;
    padding: 0;
  }
`

export const SelectPayment = styled(Flex)`
  background-color: var(--color-secondary-100);
  padding: 16px;
`

export const MediumText = styled.div`
  font-size: var(--size-font-medium);
`
export const SelectPaymentMethodText = styled.div`
  font-size: var(--size-font-medium);
  font-weight: var(--font-weight-medium);
  height: 30px;
  border-bottom: 1px solid var(--color-primary-200);
`

export const StyledRadioButtonGroup = styled(RadioButtonGroup)`
  > div:last-of-type {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-left: 8px;
  }
  > div:first-of-type {
    font-size: var(--size-font-medium);
  }
  label {
    font-size: var(--size-font-base);
  }
`
export const AmountNumberInput = styled(Number)`
  input {
    border-color: var(--color-primary-400);
    width: 165px;
    height: 32px;
    border-radius: 5px;
    font-size: var(--size-font-small);
    &::placeholder {
      color: var(--color-primary-400);
    }
    &:hover,
    &:focus {
      &::placeholder {
        color: var(--color-primary-400);
      }
    }
  }
`

export const AmountError = styled.div`
  font-size: var(--size-font-small);
  color: var(--color-error-700);
  font-family: var(--font-family-alpha);
`

export const ReachIframeContainer = styled.div`
  padding: 16px;
  min-height: 315px;
`

export const ErrorMessage = styled.div`
  padding: 11px 16px;
`

export const DisabledHeader = styled.p`
  ${typography.alpha.primaryActive.subtitle1}
  margin: 0 !important;
`
export const DisabledBody = styled.p`
  ${typography.alpha.primaryActive.body3}
  margin: 0 !important;
  color: var(--color-primary-400);
`
